<template>
<div>
    <messageModal v-if="showMessage" message="votre avatar a été mis à jour !" @closeMessage="showMessage=false"></messageModal>
    <br>
    <div class="row columns">
        <div class="large-12 columns"> 
            Choisissez votre avatar en cliquant sur l'image 
        </div>
    </div>
        <br>
    <div class="row columns">
        <div class="large-3 large-centered columns"> 
            <imageEditor ref="imgEditor" :imageSrc="getImageSrc"></imageEditor>
        </div>
    </div>
        <br>
    <div class="row columns">
        <div class="large-12 columns"> 
            <button @click="validate()">valider</button>
        </div>
    </div>
    <br>
</div>
</template>

<script>
import imageEditor from '../common/image-editor.vue'
import { mapGetters } from 'vuex'
import userAvatar from '../../api/user-avatar.api'
import messageModal from '../common/message-modal.vue'
import store from '../../store/index.js'

export default {
  name: 'myAccount',
  components: {
    imageEditor,
    messageModal
  },
  props: {
  },
  data () {
    return {
      showMessage: false
    }
  },
  computed: {
    ...mapGetters([
      'currentUserAvatar',
      'currentUser'
    ]),
    getImageSrc: function () {
      if (this.currentUserAvatar) {
        return this.currentUserAvatar.avatar
      } else {
        return 'http://via.placeholder.com/350x300'
      }
    }
  },
  created () {
    store.dispatch('getAllUserAvatar')
  },
  methods: {
    validate () {
      let avatar = {}
      avatar.user = this.currentUser.id
      avatar.avatar = this.$refs.imgEditor.currentImageSrc

      if (this.currentUserAvatar === null || this.currentUserAvatar === undefined) {
        this.createAvatar(avatar)
      } else {
        avatar.id = this.currentUserAvatar.id
        this.updateAvatar(avatar)
      }
    },
    createAvatar (avatar) {
      console.log('create avatar')
      userAvatar.api.createUserAvatar(avatar)
      .then(response => {
        this.showMessage = true
      },
      error => {
        console.log('error impossible to create user avatar')
        console.log(error)
      })
    },
    updateAvatar (avatar) {
      console.log('update avatar')
      userAvatar.api.updateUserAvatar(avatar)
      .then(response => {
        this.showMessage = true
      },
      error => {
        console.log('error impossible to update user avatar')
        console.log(error)
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.billboard {
    background-color: rgba(255,255,255,0.9);
    border-width: 1px;
    border-style: solid;
    border-color: #E1E5EC;
    margin: 1rem 0rem 1rem 0rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
    -webkit-transition: opacity 0.2s, -webkit-transform 0.2s;
	transition: opacity 0.35s, transform 0.5s;
    overflow: hidden;
}

.billboard:hover {
    -webkit-transform: scale3d(0.9,0.9,0.9);
	transform: scale3d(1.1,1.1,1);
    box-shadow: 1px 1px 3px rgba(0,0,0,0.7);
}

.billboard-thumbnail {
    padding: 0rem;
    margin: 0rem;
}

.billboard-content {
    padding: 1rem 1rem;
    overflow: inherit;
}
.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ; 
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.router-link-exact-active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// my-infos.vue?606459e8